import { render, staticRenderFns } from "./Unidade.vue?vue&type=template&id=7aa045c8"
import script from "./Unidade.vue?vue&type=script&lang=js"
export * from "./Unidade.vue?vue&type=script&lang=js"
import style0 from "./Unidade.vue?vue&type=style&index=0&id=7aa045c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports